import { Card, CardHeader, Typography } from "@mui/material";
import React from "react";
import { FaChartPie } from "react-icons/fa";

const TotalsHeader = () => {

  return (
    <Card>
      <CardHeader
        title={
          <Typography variant="h4" component="div">
            الاحصائيات النهائية
          </Typography>
        }
        avatar={<FaChartPie size={20} />}
      />
    </Card>
  );
};

export default TotalsHeader;
